//==========import components===============
import SubPagesLayout from 'layouts/SubPagesLayout';
import AboutEvent from 'components/common/AboutEvent';
import OurPartner from 'components/common/OurPartner';
import { aboutPageEventObj, partnerData } from 'helpers/commonHelper';
import TakeCareEvent from 'components/about-us/our-clients/TakeCareEvent';
import JoinEventOrganizer from 'components/common/JoinEventOrganizer';

const OurClient = () => {
  const titleDetail = {
    upperTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    middleTitle: 'dE EVENTE all PARTNERS',
    lowerTitle: '',
  };
  return (
    <div className='ourClientPage DBlock relative'>
      <AboutEvent data={aboutPageEventObj} />
      <TakeCareEvent data={partnerData} />
      <OurPartner data={partnerData} titleDetail={titleDetail} />
      <JoinEventOrganizer />
    </div>
  );
};

export default SubPagesLayout({ route: 'about us/our clients' })(OurClient);
